import { LoadingLine } from "../../../components/loading-line.js";
import { UserPrivateProductModel } from "./model.js";
import { UserPrivateProductView } from "./view.js";
import { ITEM_OPTIONS } from "../../../config/constants.js";
import { ModalController } from "../../../components/modal/controller.js";
import { CheckInputValue } from "../../../config/functions.js";
import { LoadingDot } from "../../../components/loading-dot.js";
import { Doms } from "../../../components/doms.js";

export class UserPrivateProductController {
  constructor() {
    this.model = new UserPrivateProductModel();
    this.view = new UserPrivateProductView();
    this.loading = LoadingLine.getInstance();
    this.doms = new Doms();

    this.modal = null;
    this.openning = false;
  }

  loadMain() {
    app.userPrivateController.viewGenericItems.loadMain(this, 'Mis productos', 'productos');
    history.pushState({}, '', `/user/productos`);
    document.getElementById('btn-productos').classList.add('active');
    document.getElementById('btn-header-productos').classList.add('active');
  }

  new() {
    history.pushState({}, '', `/user/productos/new`);
    this.modal = new ModalController("Publicar nuevo producto", LoadingDot.render() + '<br><br>', 'form-productos', app.userPrivateController.view.renderPublishButton('1'));
    app.userPrivateController.auth.sessionAlive()
      .then(() => {
        this.modal.doms.content.innerHTML = this.view.renderForm();
        APICRUD.Common.Select.SetData('productos-categoria', 0, ITEM_OPTIONS.Categorias.Productos);
        APICRUD.Common.Select.SetData('productos-unidad', 0, ITEM_OPTIONS.Unidades.Productos);
        APICRUD.Common.Select.SetData('productos-tiene-envio', 0, ITEM_OPTIONS.TiposDeEnvios);
        APICRUD.Common.Select.SetData('productos-moneda', 0, ITEM_OPTIONS.Monedas);
        APICRUD.Location.Selector_LoadStates('productos-provincia', '5', '0');
        APICRUD.Location.Selector_LoadCities('productos-localidad', '0', '0');
      })
      .catch(_error => {
        console.log(_error);
        this.modal.doms.modal.innerHTML = '';
        this.modal.close();
        app.userPrivateController.auth.showLogin()
      })
  }

  create() {
    if (this.modal?.modal?.classList.contains('active')) {
      this.modal.doms.content.innerHTML = this.view.renderForm();
      this.view.gallery.checkButtons();
    } else {
      this.modal = new ModalController("Publicar nuevo producto", this.view.renderForm(), 'form-productos', app.userPrivateController.view.renderPublishButton('1'));
      this.modal.show();
      this.view.gallery.checkButtons();
    }
    APICRUD.Common.Select.SetData('productos-categoria', 0, ITEM_OPTIONS.Categorias.Productos);
    APICRUD.Common.Select.SetData('productos-unidad', 0, ITEM_OPTIONS.Unidades.Productos);
    APICRUD.Common.Select.SetData('productos-tiene-envio', 0, ITEM_OPTIONS.TiposDeEnvios);
    APICRUD.Common.Select.SetData('productos-moneda', 0, ITEM_OPTIONS.Monedas);
    APICRUD.Location.Selector_LoadStates('productos-provincia', '5', '0');
    APICRUD.Location.Selector_LoadCities('productos-localidad', '0', '0');
  }

  edit(_idcod) {
    if (this.openning === true) return;
    this.openning = true;
    this.modal = new ModalController("Editar producto", LoadingDot.render() + '<br><br>', 'form-productos', '<br>');
    this.modal.show();
    this.loading.show();
    this.model.read(_idcod)
      .then((producto) => {
        this.modal.doms.content.innerHTML = this.view.renderForm(producto.data);
        this.modal.doms.titleStatus.innerHTML = app.userPrivateController.view.renderPublishButton(producto.data.visible);
        this.view.gallery.checkButtons();
        APICRUD.Common.Select.SetData('productos-categoria', producto.data.categoria, ITEM_OPTIONS.Categorias.Productos);
        APICRUD.Common.Select.SetData('productos-tiene-envio', producto.data['tiene-envio'], ITEM_OPTIONS.TiposDeEnvios);
        APICRUD.Common.Select.SetData('productos-unidad', producto.data.unidad, ITEM_OPTIONS.Unidades.Productos);
        APICRUD.Common.Select.SetData('productos-moneda', producto.data.moneda, ITEM_OPTIONS.Monedas);
        APICRUD.Location.Selector_LoadStates('productos-provincia', '5', producto.data.provincia);
        APICRUD.Location.Selector_LoadCities('productos-localidad', producto.data.provincia, producto.data.localidad);
      })
      .catch(error => {
        console.log(error);
        this.modal.close();
        let modal = new ModalController('Editar producto', 'No existe el producto.');
        modal.show();
        setTimeout(modal.close.bind(this), 5000);
      })
      .finally(() => {
        this.openning = false;
        this.loading.hide();
      });
  }

  delete(_title, _idcod) {
    this.modalDelete = new ModalController('Eliminar producto');
    this.modalDelete.doms.content.innerHTML = this.view.renderDeleteConfirmation(_title, _idcod);
  }

  deleteConfirmation(_idcod) {
    this.model.delete(_idcod)
      .then(() => {
        this.modal?.close();
        this.modalDelete?.close();
        app.userPrivateController.router('productos');
      })
      .catch(_error => {
        this.modalDelete.doms.content.innerHTML = _error;
        console.error(_error);
      });
  }

  deleteCancel() {
    this.modalDelete?.close();
  }

  save() {
    return new Promise(async (resolve, reject) => {
      let idcod = document.getElementById('productos-idcod')?.value;
      let newData = {
        titulo: document.getElementById('productos-titulo').value,
        resumen: document.getElementById('productos-resumen').value,
        descripcion: document.getElementById('productos-descripcion').value,
        imagenes: this.view.gallery.images,
        categoria: document.getElementById('productos-categoria').value,
        unidad: document.getElementById('productos-unidad').value,
        medida: document.getElementById('productos-medida').value,
        precio: document.getElementById('productos-precio').value,
        moneda: document.getElementById('productos-moneda').value || '0',
        marca: document.getElementById('productos-marca').value,
        localidad: document.getElementById('productos-localidad').value || '0',
        provincia: document.getElementById('productos-provincia').value || '0',
        'tiene-envio': document.getElementById('productos-tiene-envio').value,
        visible: document.getElementById('visible').checked === true ? '1' : '0'
      }

      if (idcod) {
        newData.idcod = idcod;
      }

      document.getElementById('productos-titulo-error').innerHTML = '';
      document.getElementById('productos-categoria-error').innerHTML = '';
      document.getElementById('productos-resumen-error').innerHTML = '';
      document.getElementById('productos-descripcion-error').innerHTML = '';
      document.getElementById('productos-precio-error').innerHTML = '';
      document.getElementById('productos-moneda-error').innerHTML = '';
      document.getElementById('productos-medida-error').innerHTML = '';
      document.getElementById('productos-unidad-error').innerHTML = '';
      document.getElementById('productos-tiene-envio-error').innerHTML = '';
      document.getElementById('productos-status').innerHTML = '';

      if (!newData.categoria || newData.categoria === '0') {
        document.getElementById('productos-categoria-error').innerHTML = 'Debe seleccionar una categoría.';
        document.getElementById('productos-categoria').focus();
        return;
      } else if (!newData.titulo) {
        document.getElementById('productos-titulo-error').innerHTML = 'El título no puede estar vacío.';
        document.getElementById('productos-titulo').focus();
        return;
      } else if (newData.titulo.length < 5) {
        document.getElementById('productos-titulo-error').innerHTML = 'El título debe tener al menos 5 caracteres.';
        document.getElementById('productos-titulo').focus();
        return;
      } else if (!newData.resumen) {
        document.getElementById('productos-resumen-error').innerHTML = 'La descripción corta no puede estar vacía.';
        document.getElementById('productos-resumen').focus();
        return;
      } else if (newData.resumen.length < 20) {
        document.getElementById('productos-resumen-error').innerHTML = 'La descripción debe tener al menos 20 caracteres.';
        document.getElementById('productos-resumen').focus();
        return;
      } else if (!newData.medida || newData.medida === '0') {
        document.getElementById('productos-medida-error').innerHTML = 'Debe ingresar el volumen del producto.';
        document.getElementById('productos-medida').focus();
        return;
      } else if (!CheckInputValue('productos-medida')) {
        document.getElementById('productos-medida-error').innerHTML = 'La medida no puede ser menor a cero.';
        document.getElementById('productos-medida').focus();
        return;
      } else if (!newData.unidad || newData.unidad === '0') {
        document.getElementById('productos-unidad-error').innerHTML = 'Debe seleccionar la unidad del volumen.';
        document.getElementById('productos-unidad').focus();
        return;
      } else if (document.getElementById('productos-precio-radio-1').checked == true) {
        if (newData.precio.trim() == '' || newData.precio.trim() == '0') {
          document.getElementById('productos-precio-error').innerHTML = 'El precio no puede estar vacío.';
          document.getElementById('productos-precio').focus();
          return;
        } else if (!CheckInputValue('productos-precio')) {
          document.getElementById('productos-precio-error').innerHTML = 'El precio no puede ser menor a cero.';
          document.getElementById('productos-precio').focus();
          return;
        } else if (newData.moneda === '0') {
          document.getElementById('productos-moneda-error').innerHTML = 'Debe seleccionar una moneda.';
          document.getElementById('productos-moneda').focus();
          return;
        }
      }

      document.getElementById('productos-status').innerHTML = 'Guardando...';

      let func = 'Create';
      let text = 'Creando nuevo producto';
      if (newData.idcod) {
        func = 'Update';
        text = 'Guardando producto';
      }

      if (await app.userPrivateController.account.canPublish(this.doms.getDom('visible').checked, newData.idcod) === false) {
        document.getElementById('visible').checked = false;
        newData.visible = '0';
      }

      let modalSave = new ModalController('Guardando', 'Enviando datos, por favor espere...');
      modalSave.show();
      this.loading.show(text);
      this.model.save(newData, func)
        .then(_result => {
          document.getElementById('productos-status').innerHTML = 'Datos guardados.';
          app.userPrivateController.router('productos');
          app.userPrivateController.productos.modal.close();
          modalSave.doms.content.innerHTML = 'Datos guardados.';
          resolve();
        })
        .catch(_error => {
          document.getElementById('productos-status').innerHTML = _error;
          modalSave.doms.content.innerHTML = _error;
          reject();
        })
        .finally(() => {
          this.loading.hide();
          modalSave.close();
        });

    });
  }
}
